import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase/config";

function AdminRoute({ children }) {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const userRef = doc(db, "users", user.uid);
          const userSnap = await getDoc(userRef);

          const role = userSnap.exists() ? userSnap.data().role : null;
          setIsAdmin(role === "admin");
        } catch (error) {
          console.error("❌ Error fetching role:", error);
        }
      } else {
        // ✅ Handle unauthenticated users also
        setIsAdmin(false);
      }

      setLoading(false); // ✅ Always stop loading
    });

    return () => unsubscribe();
  }, []);

  if (loading) return <p>Loading...</p>;

  return isAdmin ? children : <Navigate to="/" />;
}

export default AdminRoute;
